// extracted by mini-css-extract-plugin
module.exports = {"root":"RegisterSuccess_root__AkxoQ","wrapper":"RegisterSuccess_wrapper__Di6Ty","buttons":"RegisterSuccess_buttons__Sejr3","button":"RegisterSuccess_button__U7ueX"};